import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { CountryFlag } from 'src/components/country-flag';
import { ParamsAndReturnTypes } from 'src/components/translate';

interface ICountryBadge {
  countryCode: string;
}

export const CountryBadge: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ICountryBadge>
>> = props => {
  const { countryCode } = props;
  const { t } = useAppContext();

  return (
    <CountryFlag
      countryCode={countryCode}
      title={t(
        'common',
        `market.${countryCode}` as keyof ParamsAndReturnTypes['common']
      )}
      tooltipPlacement="top"
    />
  );
};
